<div class="vfilter-container">
  <div class="filter-container">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="header">
          <div class="title">
            <h2>Filter</h2>
          </div>
          <div class="actions">
            <button mat-button color="primary" (click)="clearAll()">Clear All</button>
          </div>
        </div>
        <v-form
          [formOptions]="formOptions"
          [showDefaultSnackbars]="false"
          inputWidth="100%"
          fieldWidth="220px"
          [compact]="true"
          (formLoadSuccess)="handleFormEvent($event)"
          (formSubmitResult)="updateFeed($event)"
          (formSubmitFn)="handleFormSubmitFnEvent($event)"
        ></v-form>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="results">
    <ng-content></ng-content>
    <div
      *ngIf="!!infiniteScroll"
      inViewport
      [inViewportOptions]="{ threshold: 0 }"
      (inViewportAction)="onScroll()"
    ></div>
  </div>
</div>
